import radapter from './src/radapter-factory';

export default radapter;
